<template>
	<div class="about">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/teamBg.jpg" />
		<div class="imgBoxArea" >
			<div class="imgBoxItem a">
				<div class="teamRow">
					<img class="wow fadeIn" src="../../assets/person_mourong.jpg" @click="imgClick('mourong')"/>
					<img class="wow fadeIn" src="../../assets/person_niuchaoye.jpg" @click="imgClick('niuchaoye')"/>
				</div>
				<div class="teamRow">
					<img class="wow fadeIn" src="../../assets/person_chenhaitao.jpg" @click="imgClick('chenhaitao')"/>
					<img class="wow fadeIn" src="../../assets/person_wanghui.jpg" @click="imgClick('wanghui')"/>
				</div>
			</div>		
		</div>
		<el-dialog width="80%"  :visible.sync="dialogTableVisible">
			<div  class="cardBox">
				<div class="a" v-html="persons[selectP].title"></div>
				<div class="b" v-html="persons[selectP].info"></div>
			</div>
					  
		</el-dialog>
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'Home',
		data() {
			return {
				dialogTableVisible:false,
				selectP:'mourong',
				persons:{
					'mourong':{
						title:'牟榕',
						info:'牟榕先生自2022年起担任橙猩数娱董事长，亦自2020年起担任橙猩数娱母公司天下票仓（上海）网络科技有限公司的董事长。<br><br>牟榕先生是御岭资本集团的创始暨管理合伙人。御岭资本是一家根植大中华地区、面向全球市场的私募投资管理和财务咨询机构，专注于娱乐传媒和医疗健康领域的跨境投资机会。牟榕先生目前还担任多家位于中国、中国香港特别行政区、以色列、新加坡、美国、瑞士和开曼群岛之法人团体的董事。<br><br>牟榕先生自2007年起先后任职于香港汉威资本有限公司（后更名为华润资本）、永灵通金融集团和仕富资本有限公司，具备丰富的资本运作和企业管理经验。在此之前牟榕先生是一位资深的交易律师（纽约州律师执照），在美国美迈斯律师事务所（O’Melveny & Myers LLP）执业近8年（1999-2006），并曾任美国科律律师事务所（Cooly LLP）业务发展高级顾问（2013-2014）。<br><br>此外，牟榕先生还曾于2014至2015年期间担任总部位于新加坡的玮仕教育集团董事，在中国长沙、南昌等地投资和管理国际学校和双语学校；于2021至2023年期间担任香港奥森时尚集团联席董事长，奥森是中国最早的创意产业社区与“非标商业”运营商之一，拥有上海8号桥、北京隆福寺等知名作品。牟榕先生也曾担任上海对外经贸大学法学院的客座教授（2014-2017）和法律硕士研究生产业导师（2021-2024）。<br><br>牟榕先生毕业于美国哈佛大学法学院（法学硕士，2002年）和上海对外经贸大学（法学士，1996年；法学硕士，1999年）。'
					},
					'niuchaoye':{
						title:'牛朝野',
						info:'牛朝野先生现任橙猩数娱总经理。<br><br>2020年加入公司，担任数字化产品负责人，在职期间主导完成了全牌照数字资产运营平台项目。<br><br>牛朝野先生此前曾参与国家海关数智化系统建设，以及昆仑集团智能化数字调魔系统的开发实施工作。具备数字化项目全流程管理及落地运营经验，涵盖政府关系协调、技术实施推进、营销体系搭建及票务系统运营等核心环节。<br><br>牛朝野先生毕业于西南石油大学（能源应用工程，2014年）。'
					},
					'chenhaitao':{
						title:'陈海涛',
						info:'陈海涛先生现任公司首席商务官。<br><br>陈海涛先生曾为江西少儿素材教育联盟创办人。（行业领先的OMO教育平台）独创"三维一体"短视频营销体系。打造"演出+短视频"创新模式，孵化数字新空间平台，年服务用户200万+。<br><br>陈海涛先生8年深耕数字营销领域，操盘多个千万级流量项目。兼具战略思维与落地能力，擅长从0到1打造数字文化IP。<br><br>陈海涛先生为抖音官方认证高级运营师、腾讯课堂特邀短视频营销讲师。<br><br>陈海涛先生毕业于南昌航空大学。'
					},
					'wanghui':{
						title:'王晖',
						info:'王晖先生现任公司首席营销官。<br><br>王晖先生专注文化教育领域项目孵化与营销深耕少儿教育领域12年，构建"文化+教育"创新生态，联盟覆盖200+教育机构成功创办25所标准化连锁培训机构。<br>独创"素质教育4.0"营销体系，培养超10万名学员。精通文化教育机构品牌建设与商业模式创新。12年文化教育领域营销，操盘多个百万级流量项目。<br><br>王晖先生精通抖音、快手、小红书、视频号全平台运营策略具备文化教育产业全链条操盘经验，从单店运营到平台生态构建。<br><br>王晖先生为江西省文化产业协会特聘专家、数字营销领域行业专家。<br><br>王晖先生毕业于江西财经大学（企业管理硕士）。'
					},
					'chenyu':{
						title:'陈羽',
						info:'陈羽女士自2015年加入公司，2023年起担任公司运营总监，全面负责公司电影票务业务，在电影、票务领域具备一定的运营管理经验。<br><br>陈羽女士拥有15年影视演出领域全链路项目管理经验。曾任职于文汇新民报业集团、掌尚信息服务等公司；在演出项目制定、全国巡演推广以及运营方面具有丰富的经验，曾与上海话剧艺术中心合作在全国范围成功巡演多部知名话剧。<br><br>陈羽女士毕业于华东师范大学（教育管理专业）。'
					},
					'yuxueqing':{
						title:'虞学青',
						info:'虞学青自2021年起加入天下票仓任人事行政总监。统筹人力资源战略规划、行政体系搭建及跨部门协同，以跨行业管理经验赋能企业发展。<br><br>虞学青先前从事于酒店管理、及奢侈品牌行业领域。曾任职于锦江集团（采购经理）、南影咨询（上海）有限公司（项目总监）、香港宜进利集团（市场总监），颖川堂（上海）广告有限公司（运营总监）。任职期间带领团队成功斩获多个国际知名奢侈品牌的国内独家代理经销权。<br><br>虞学青毕业于东华大学拉萨尔设计学院的市场营销专业。'
					},
					'xiawenjie':{
						title:'夏文杰',
						info:'夏文杰先生自2020年起担任公司CFO，自2026年6月起担任公司首席战略官。<br><br>夏文杰先生对中国资本市场拥有全面的认识，在银行、证券、基金管理等行业经验丰富，曾就职于中信证券、平安集团、嘉实基金等金融机构，具有丰富的资本运作、金融合规管理经验。<br><br>夏文杰先生毕业于中国人民大学（金融学硕士）和上海对外经贸大学（管理学学士）。'
					},
				}
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/team'});
			}
		},
		mounted() {
			this.$nextTick(() => {				
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},
		methods:{
			imgClick(name){
				this.selectP=name
				this.dialogTableVisible=true
			}
		}
	}
</script>
<style lang="less" scoped>
	.cardBox{
		max-height: 80vh;
		overflow-y: auto;
		margin: 40px;
		.a{
			font-size: 30px;
			text-align: left;
			color: #333 !important;
			font-weight: bold;
			margin-bottom: 20px;
		}
		.b{
			line-height: 40px;
			font-size: 18px;
			color: #777;
			text-align: left;
		}
	}
	.imgBoxArea{
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 80px;
	}
	.imgBoxItem{
		margin-bottom: 10px;
		.teamRow{
			display: flex;
			align-items: flex-start;
			gap: 10px;
			margin-bottom: 10px;
			&:last-child{
				margin-bottom: 0;
			}
		}
		img{
			display: block;
			flex: none;
			cursor: pointer;
		}
	}

	@media (max-width:1440px) {
		.imgBoxArea{
			width: 800px;
			margin: 0 auto;
		}
		.imgBoxItem{
			img{
				height: 280px;
			}
		}
		.cardBox{
			margin: 20px;
			.a{
				font-size: 20px;
			}
			.b{
				font-size: 12px;
				line-height:26px;
			}
		}
	}
	@media (max-width:800px) {
		.imgBoxArea{
			width: 400px;
			margin: 0 auto;
		}
		.imgBoxItem{
			img{
				height: 140px;
			}
		}
		.cardBox{
			margin: 10px;
			.a{
				font-size: 20px;
			}
			.b{
				font-size: 12px;
				line-height:26px;
			}
		}
	}
</style>
